import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h4 className="text-lg font-heading font-semibold text-background-50 mb-4">
              Hipobuy <span className="text-primary-400">Sheet</span>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              Your trusted resource for spreadsheet-based shopping research. Independent guides, product comparisons, and category navigation — all designed to help you shop smarter.
            </p>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">Quick Links</h5>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/hipobuy-sheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Complete Hipobuy Sheet Guide
                </Link>
              </li>
              <li>
                <Link to="/hipobuy-sheet-safety" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Safety &amp; Security Guide
                </Link>
              </li>
              <li>
                <Link to="/hipobuy-sheet-comparison" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Spreadsheet Comparison
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Visit Main Site
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">Popular Categories</h5>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Hoodies / Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Jackets
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} Hipobuy Sheet Guide. All rights reserved. This is an independent resource and is not affiliated with the official Hipobuy company.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              Main Platform
            </a>
            <Link to="/hipobuy-sheet-guide" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              SEO Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}